import React, { useEffect, useState } from 'react'
import ElementoChartDolori from 'componenti/elementoChartDolori'
import SignaturePad from 'signature_pad'
import CleaningServicesIcon from '@mui/icons-material/CleaningServices'
import TuneIcon from '@mui/icons-material/Tune'
import Icon from '@mui/material/Icon'
import NotificationItem from 'examples/Items/NotificationItem'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import Menu from '@mui/material/Menu'
import corpoUmano from 'assets/images/corpoUmano.jpg'
import MDBox from 'components/MDBox'
import { newId } from 'data/strumenti'

export default function elementoDisegnaDolore(props) {
    const [pad, setPad] = useState({})
    const [altezza, setAltezza] = useState(400)
    const [elementiEliminati, setElementiEliminati] = useState([])
    const [coloreAttivo, setColoreAttivo] = useState(5)
    const colori = ['rgb(204, 0, 0)', 'rgb(255, 148, 77)', 'rgb(255, 255, 0)', 'rgb(0, 230, 0)', 'rgb(0, 102, 255)', 'rgb(0, 0, 0)']
    const apriMenuSvuota = (event) => setMenuSvuota(event.currentTarget)
    const chiudiMenuSvuota = () => setMenuSvuota(false)
    const [menuSvuota, setMenuSvuota] = useState(false)
    const [listaDisegni, setListaDisegni] = useState([])
    const [nuovoDisegno, setNuovoDisegno] = useState({})

    const disegnaPad = () => {
        var listaDisegniPad = listaDisegni.map((disegno) => {
            if (disegno !== undefined) {
                const valoreConversione = altezza / disegno.dimensione
                var nuovoDisegnoPad = { color: disegno.datiDisegno.color }
                nuovoDisegnoPad.points = disegno.datiDisegno.points.map((coordinate) => {
                    var nuove = { time: coordinate.time }
                    nuove.x = coordinate.x * valoreConversione
                    nuove.y = coordinate.y * valoreConversione
                    return nuove
                })
                return nuovoDisegnoPad
            }
            return {color : 'black', points : [{time : 0, x : 0, y : 0}]}
        })
        pad.fromData(listaDisegniPad)
    }

    const creaPad = () => {
        let nuovoPad = new SignaturePad(document.getElementById('pad-body-chart'), {
            onEnd: (e) => {
                let data = nuovoPad.toData()
                setNuovoDisegno(data[data.length - 1])
                setElementiEliminati([])
            },
        })
        document.getElementById('pad-body-chart').addEventListener('handleMouseUp', (e) => {})
        setPad(nuovoPad)
        setListaDisegni(props.datiImmagine)
    }

    useEffect(() => {
        if (Object.keys(pad).length !== 0) {
            disegnaPad()
        }
    }, [listaDisegni])

    useEffect(() => {
        if (Object.keys(nuovoDisegno).length !== 0) {
            var nuovaLista = [...listaDisegni]
            nuovaLista.push({ dimensione: altezza, datiDisegno: nuovoDisegno })
            setListaDisegni(nuovaLista)
        }
    }, [nuovoDisegno])

    useEffect(() => {
        function getAltezza() {
            let nuovaLtezza = document.getElementById('contenitore-body-chart').clientWidth
            setAltezza(nuovaLtezza)
            if (Object.keys(pad).length !== 0) {
                disegnaPad()
            }
            return
        }
        window.addEventListener('resize', getAltezza)
        getAltezza()
        return () => window.removeEventListener('resize', getAltezza)
    }, [altezza])

    useEffect(() => {
        creaPad()
    }, [])
    const svuotaBodyChart = (svuota) => {
        if (svuota) {
            setElementiEliminati([])
            setListaDisegni([])
        }
        chiudiMenuSvuota()
    }

    const cambiaColore = (colore, index) => {
        setColoreAttivo(index)
        pad.penColor = colore
    }

    const undo = () => {
        let nuovaLista = [...elementiEliminati]
        let nuovaListaDisegni = [...listaDisegni]
        nuovaLista.unshift(listaDisegni[listaDisegni.length - 1])
        nuovaListaDisegni.pop()
        setElementiEliminati(nuovaLista)
        setListaDisegni(nuovaListaDisegni)
    }

    const redo = () => {
        if (elementiEliminati.length === 0) {
            return
        }

        let nuovaLista = [...elementiEliminati]
        let nuovaListaDisegni = [...listaDisegni]
        nuovaListaDisegni.push(nuovaLista[0])
        nuovaLista.shift()
        setListaDisegni(nuovaListaDisegni)
        setElementiEliminati(nuovaLista)
    }

    const salva = () => {
        //props.salva({idImmagine : newId(), immagine : pad.toData() })
        props.salva(listaDisegni)
    }

    const renderColori = () => {
        return colori.map((colore, index) => {
            let selezionato = coloreAttivo === index
            return <div key={colore} className={`colore-body-chart ${selezionato ? 'colore-selezionato-body-chart' : ''}`} style={{ backgroundColor: colore }} onClick={(e) => cambiaColore(colore, index)}></div>
        })
    }

    const renderMenuSvuota = () => (
        <Menu
            anchorEl={menuSvuota}
            anchorReference={null}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={Boolean(menuSvuota)}
            onClose={chiudiMenuSvuota}
            sx={{ mt: 2 }}>
            <MDTypography veriant='subTitle1' mb={1}>
                Vuoi svuotare la body chart?
            </MDTypography>
            <div className='contenitore-bottoni-destra'>
                <MDButton size='small' onClick={() => svuotaBodyChart(false)}>
                    No
                </MDButton>
                <MDButton size='small' onClick={() => svuotaBodyChart(true)}>
                    Si
                </MDButton>
            </div>
        </Menu>
    )

    return (
        <div className='fletti-verticalmente'>
            {renderMenuSvuota()}
            <div id='contenitore-body-chart'>
                <div id='parte-sopra-body-chart' className='comandi-body-chart'>
                    <div id='lista-colori-body-chart' className='centrato'>
                        {renderColori()}
                    </div>
                    <Icon fontSize='large' sx={{ cursor: 'pointer' }} color='error' onClick={(e) => apriMenuSvuota(e)}>
                        <CleaningServicesIcon />
                    </Icon>
                </div>
                <MDBox
                    sx={{
                        backgroundImage: () => ` url(${corpoUmano})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'grid',
                        placeItems: 'center',
                        height: `${altezza}px`,
                        boxSizing: 'border-box',
                        width: `${altezza}px`,
                    }}
                    id='parte-centrale-body-chart'
                    /* style={{ height: `${altezza}px`, overflow: 'hidden' }} */
                >
                    {/* <ElementoChartDolori pointer={{}} disegno={true} pointerGiaInseriti={[]} /> */}
                    <canvas id='pad-body-chart' className='img-body-chart-output' style={{ bottom: '0px' }} width={`${altezza}px`} height={`${altezza}px`}></canvas>
                </MDBox>
                <div id='parte-sotto-body-chart' className='comandi-body-chart'>
                    <Icon fontSize='large' sx={{ cursor: 'pointer' }} onClick={() => undo()}>
                        undo
                    </Icon>
                    <Icon fontSize='large' sx={{ cursor: 'pointer' }} color={elementiEliminati.length === 0 ? 'disabled' : 'inherit'} onClick={() => redo()}>
                        redo
                    </Icon>
                </div>
            </div>
            <div className='contenitore-bottoni-destra'>
                <MDButton variant='contained' color='error' onClick={() => props.chiudi()}>
                    annulla
                </MDButton>
                <MDButton variant='contained' color='primary' onClick={() => props.indietro(listaDisegni)}>
                    indietro
                </MDButton>
                <MDButton variant='contained' color='primary' onClick={() => salva()}>
                    avanti
                </MDButton>
            </div>
        </div>
    )
}
